module.exports = __webpack_public_path__ + "img/eurotext_logo_optimized.fb8a31da.svg";